import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import ProteinModal from "./Components/ProteinModal";

export default function AdminProtein()
{
    const [proteins, setProteins] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedProtein, setSelectedProtein] =
        useState<any>(null);

    const loadProteins = async () => {

        const response =
            await api.get(
                '/proteins'
            );

        setProteins(
            response.data
        );
    };

    useEffect(() => {

        loadProteins();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedProtein
        ) {

            await api.post(

                `/proteins/${selectedProtein.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/proteins',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedProtein(
            null
        );

        loadProteins();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this protein?'
            )
        ) {
            return;
        }

        await api.delete(
            `/proteins/${id}`
        );

        loadProteins();
    };

    const moveProteinUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...proteins];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setProteins(
            updated
        );

        await api.post(
            '/proteins/reorder',
            {
                proteins:
                    updated.map(
                        (
                            protein,
                            position
                        ) => ({
                            id:
                            protein.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadProteins();
    };

    const moveProteinDown = async (
        index: number
    ) => {

        if (
            index >=
            proteins.length - 1
        ) {
            return;
        }

        const updated =
            [...proteins];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setProteins(
            updated
        );

        await api.post(
            '/proteins/reorder',
            {
                proteins:
                    updated.map(
                        (
                            protein,
                            position
                        ) => ({
                            id:
                            protein.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadProteins();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Proteins
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedProtein(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Protein
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {proteins.map(
                    (
                        protein,
                        index
                    ) => (

                        <tr
                            key={
                                protein.id
                            }
                        >

                            <td>
                                {
                                    protein.name
                                }
                            </td>

                            <td>
                                {
                                    protein.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveProteinUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveProteinDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedProtein(
                                                protein
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                protein.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <ProteinModal

                    protein={
                        selectedProtein
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
